import api from '../../../App/socket';

export const getModulesStructure = () => (
    api.send({
        api: 'module',
        module: 'App',
        classMethod: 'GetModuleStructure',
        options: {},
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/requests/get_modules_structure_request.js